import * as Service from 'types/service';
import { ChronoUnit, Duration, Instant } from '@js-joda/core';

export const useTimeSinceSeated = (party: Service.Party) => {
  const { seatedTime } = party;

  const hasSeatedTime = seatedTime !== undefined;
  const instantSeated = hasSeatedTime ? Instant.ofEpochSecond(seatedTime, 0) : undefined;
  const timeSinceSeated = instantSeated
    ? Duration.ofSeconds(instantSeated.until(Instant.now(), ChronoUnit.SECONDS))
    : undefined;

  return timeSinceSeated;
};
